import axios from "axios";
export default {
    getAvailableDocumentObjectIds: (documentId) => axios.post("/Table/GetAvailableDocumentObjectIds", { documentId }),
    getDocumentTableData: (documentId, documentObjectIdFilter, nodeIds, abortController) => axios.post("/Table/GetDocumentTableData", {
        documentId,
        documentObjectIdFilter,
        nodeIds
    }, { signal: abortController.signal }),
    saveDocumentTableData: (document) => axios.post("/Table/SaveDocumentTableData", document),
    getNodeSources: (documentId, nodeIds) => axios.post("/Documents/GetNodeSources", { documentId, nodeIds })
};
